import React from 'react';
import { Center, Loader, Modal } from '@mantine/core';

const EventLoading: React.FC = () => (
  <Modal.Content>
    <Modal.Body>
      <Center h="50dvh">
        <Loader type="dots" />
      </Center>
    </Modal.Body>
  </Modal.Content>
);

export default EventLoading;
